import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { CreatePaymentTermContainer } from "@/screens/Accounting/subfeatures/PaymentTerms"

export const Route = createFileRoute("/app/admin/accounting/create-payment-term")({
  component: () => (
    <PermissionContentWrapper
      permissions={[PermissionActionType.ACCOUNTING_MANAGER, PermissionActionType.ACCOUNTING_MAINTENANCE]}
    >
      <CreatePaymentTermContainer />
    </PermissionContentWrapper>
  ),
})
